import { useEffect, useState, useCallback } from 'react';
import { usePost } from '../usePost';

export const useTelegramLogin = (ChatId) => {
    const [login, setLogin] = useState(() => !!localStorage.getItem("ACCESS_TOKEN"));

    const storedToken = localStorage.getItem("ACCESS_TOKEN");
    const storedChatId = localStorage.getItem("telegram_chat_id");

    // گرفتن دیتای امن تلگرام
    const initData = window.Telegram?.WebApp?.initData || "";

    // فقط اگر لاگین نبود و ChatId داشتیم ریکوئست بزند
    const shouldFetch = !storedToken && Boolean(ChatId);

    const { data } = usePost(
        shouldFetch ? `jwt/login` : null,
        { 
            init_data: initData,
            chat_id: ChatId // در صورت نیاز بک‌اند به چت‌آیدی صریح
        }
    );

    const clearLogin = useCallback(() => {
        localStorage.removeItem("ACCESS_TOKEN");
        localStorage.removeItem("USER_ID");
        localStorage.removeItem("isProfileComplete");
        localStorage.removeItem("telegram_chat_id");
        window.dispatchEvent(new Event('profileUpdated'));
        setLogin(false);
    }, []);

    // اگر کاربر تلگرام عوض شده بود، دیتای قبلی پاک شود تا مجدد لاگین انجام گیرد
    useEffect(() => {
        if (storedChatId && ChatId && String(storedChatId) !== String(ChatId)) {
            clearLogin();
        }
    }, [ChatId, storedChatId, clearLogin]);

    // دریافت و ثبت پاسخ ورود
    useEffect(() => {
        if (!data) return;

        if (data.success && data.data) {
            const resData = data.data; // محتویات داخل data
            const user = resData.user || {};

            // 1. ذخیره توکن JWT
            const token = resData.token || resData.access_token;
            if (token) {
                localStorage.setItem("ACCESS_TOKEN", token);
            }

            // 2. ذخیره تلگرام ChatId
            if (ChatId) {
                localStorage.setItem("telegram_chat_id", String(ChatId));
            }

            // 3. ذخیره شناسه کاربر (اگر بک‌اند id فرستاده بود، وگرنه خود ChatId)
            const userId = user.id || ChatId;
            if (userId) {
                localStorage.setItem("USER_ID", String(userId));
            }

            // 4. ذخیره وضعیت تکمیل بودن پروفایل
            const isComplete = Boolean(
                resData.isProfileComplete ?? 
                resData.is_profile_complete ?? 
                user.isProfileComplete
            );

            if (isComplete) {
                localStorage.setItem("isProfileComplete", "true");
            } else {
                localStorage.removeItem("isProfileComplete");
            }

            // انتشار ایونت برای به‌روزرسانی سایر کامپوننت‌ها (مثل هدر)
            window.dispatchEvent(new Event('profileUpdated'));
            setLogin(true);
        } else {
            clearLogin();
        }
    }, [data, ChatId, clearLogin]);

    return { login, ChatId };
};
